import React from 'react'
import moment from 'moment'

import { connect } from 'react-redux'
import { settingConfigs } from '@/configurations'
import WarningIcon from '@/assets/images/icons/icon_manytabswarning.png'

class ImportantNotesDialog extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { language, lastLoginTime } = this.props
    return (
      <React.Fragment>
        <div style={{ width: '550px', padding: '30px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-around', paddingBottom: '25px' }}>
            <img src={WarningIcon} alt='warning icon' />
          </div>
          <section>
            <p style={{ lineHeight: '20px', textAlign: 'center', fontWeight: 'bold' }}>{language.important_notes_warning}</p>
            <p style={{ textAlign: 'center', padding: '40px' }}>
              {language.important_notes_login_date}&nbsp;
              {lastLoginTime ? moment(lastLoginTime).format(settingConfigs.LONG_DATE) : '--/--/--- --:--:--'}
              <b></b>
            </p>
          </section>
        </div>
      </React.Fragment>
    )
  }
}

export default connect(state => ({
  language: state.app.language,
  lastLoginTime: state.auth.lastLoginTime
}))(ImportantNotesDialog)
